export default __webpack_public_path__ + "static/media/icon-lixeira.5e087804.svg";